var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 24,
    viewBox: "0 0 512 512",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m207.125 422.641c-82.925-17.776-143.125-92.341-143.125-177.308 0-99.989 81.344-181.333 181.333-181.333 84.969 0 159.532 60.2 177.3 143.13a21.338 21.338 0 0 0 41.73-8.937c-21.963-102.479-114.082-176.86-219.03-176.86-123.51 0-224 100.485-224 224 0 104.948 74.375 197.063 176.855 219.026a21.332 21.332 0 1 0 8.937-41.718z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m224 117.333v106.667h-64a21.334 21.334 0 0 0 0 42.667h85.333a21.335 21.335 0 0 0 21.334-21.334v-128a21.334 21.334 0 0 0 -42.667 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m373.333 234.667c-76.458 0-138.666 62.2-138.666 138.666s62.208 138.667 138.666 138.667 138.667-62.2 138.667-138.667-62.208-138.666-138.667-138.666zm0 234.666a96 96 0 1 1 96-96 96.108 96.108 0 0 1 -96 96z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m373.333 298.667a21.334 21.334 0 0 0 -21.333 21.333v53.333a21.334 21.334 0 1 0 42.667 0v-53.333a21.334 21.334 0 0 0 -21.334-21.333z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 373.333,
    cy: 426.667,
    r: 21.333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default __webpack_public_path__ + "static/media/Late.7ea2a4c5b106b1550b7adbcc965a4111.svg";
export { ForwardRef as ReactComponent };